module.exports = __webpack_public_path__ + "img/video-player/love-45ab7c47df0f8a081bcb48d9974a8664.png";